





import { Component, Vue, Prop } from "vue-property-decorator";
import { antiShake } from "@/common/decorator";
import { Toast } from "vant";
import request from "@/common/request";
import Native from "../common/Native";

interface IResponse {
  code: number;
  message: string;
  sessionId: string;
  data: boolean;
}

@Component
export default class Zan extends Vue {
  @Prop()
  private appId!: string;

  @Prop()
  private infoId!: string;

  private isShow: boolean = true;

  created() {
    this.isShow =
      !Native.isOpenInApp() &&
      (this.$route.query.openhdstatic as string) != "2";
  }

  @antiShake(2000)
  click() {
    this.animate();
  }
  animate() {
    this.doPraiseShare().then(result => {
      if (!result.data) {
        Toast.fail(result.message);
      } else {
        const img: HTMLImageElement = this.$refs.image as HTMLImageElement;
        img.src = require("../assets/zan-gif.gif");
        setTimeout(() => {
          img.src = require("../assets/zan.png");
        }, 1000);
      }
    });
  }
  doPraiseShare(): Promise<IResponse> {
    return request.post("/doPraiseShare.html", {
      appId: this.appId,
      title: "",
      version: "v",
      type: "0",
      sourceId: this.infoId,
      sourceType: "1"
    });
  }
}
